module.exports = __webpack_public_path__ + "img/phone.f483c340.png";